import { render } from "./BnkV2.vue?vue&type=template&id=d42e3454&scoped=true"
import script from "./BnkV2.vue?vue&type=script&lang=js"
export * from "./BnkV2.vue?vue&type=script&lang=js"

import "./BnkV2.vue?vue&type=style&index=0&id=d42e3454&scoped=true&lang=css"
import "./BnkV2.vue?vue&type=style&index=1&id=d42e3454&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d42e3454"]])

export default __exports__